import React from "react";
import closed from "assets/images/we-are-closed.svg";
import { useAppSelector } from "hooks/store";
import { useNavigate } from "react-router-dom";
import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";

type Props = {};

const ShopClosed = (props: Props) => {
  const { settings, companyData } = useAppSelector(({ main }) => main);
  return (
    <div className="h-screen">
      <div className="h-[60px] bg-primary px-[20px] flex items-center  shadow-[0px_10px_10px_5px_#00000024] z-10 ">
        {settings?.showLogo !== 0 ? (
          <div
            onDoubleClick={() => {
              window.location.href = "/admin/setting/time";
            }}
            className="text-white !px-1.5 relative"
          >
            <img
              src={companyData?.logoUrl}
              alt=""
              className="h-14 w-14 rounded-md mr-3"
            />
          </div>
        ) : (
          <div
            onDoubleClick={() => {
              window.location.href = "/admin/setting/time";
            }}
            className="text-white !px-1.5 relative"
          >
            <AdminPanelSettingsIcon className="text-white" />
          </div>
        )}

        {!!settings.ShowCompanyName && !!companyData?.companyName && (
          <a href="/">
            <h1 className="text-lg md:text-xl font-bold text-themeSelColor ">
              {companyData?.companyName}
            </h1>
          </a>
        )}
      </div>
      <div className="flex flex-col min-h-screen justify-center items-center bg-gray-50">
        <div className="flex flex-col justify-center items-center ">
          <img
            src={closed}
            alt="Closed Sign"
            className="max-w-xs sm:max-w-sm md:max-w-md lg:max-w-lg h-auto shadow-lg rounded-lg"
          />
        </div>
      </div>
    </div>
  );
};

export default ShopClosed;
